<template>
  <v-container class="px-0">
    <component :is="headingTag" :class="headingClasses">{{ headingText }}</component>
    <slot></slot>
  </v-container>
</template>

<script>
import { TYPOGRAPHY_CLASSES, FONT_WEIGHT_CLASSES, VUETIFY_COLORS } from '@/config/vuetifyTypes'

export default {
  props: {
    headingText: {
      type: String,
      required: true
    },
    headingLevel: {
      type: String,
      default: '1'
    },
    headingClass: {
      type: String,
      default: 'headline',
      validator: val => TYPOGRAPHY_CLASSES.includes(val)
    },
    headingWeight: {
      type: String,
      default: 'font-weight-bold',
      validator: val => !val || FONT_WEIGHT_CLASSES.includes(val)
    },
    headingColor: {
      type: String,
      default: '',
      validator: val => !val || VUETIFY_COLORS.includes(val)
    }
  },

  computed: {
    headingTag () {
      return 'h' + this.headingLevel
    },
    headingClasses () {
      return [
        this.headingClass,
        this.headingWeight,
        this.headingColor ? `${this.headingColor}--text` : null
      ].filter(Boolean)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ViewWrapper.vue